var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAustria(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 5.33333H0V0.888889C0 0.397778 0.391562 0 0.875 0H20.125C20.6084 0 21 0.397778 21 0.888889V5.33333Z",
    fill: "#DA1E05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 5.33325H0V10.6666H21V5.33325Z",
    fill: "#E6E6E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 15.1112C21 15.6023 20.6084 16.0001 20.125 16.0001H0.875C0.391562 16.0001 0 15.6023 0 15.1112V10.6667H21V15.1112Z",
    fill: "#DA1E05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAustria);
export default __webpack_public_path__ + "static/media/austria.ad699262.svg";
export { ForwardRef as ReactComponent };